<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { DOCUMENTATION_WEBSITE } from '@constants'
import { DropdownMenuItem as RekaDropdownMenuItem } from 'reka-ui'

import DropdownMenuItem from '@uikit/menu/dropdown/DropdownMenuItem.vue'
import DropdownMenuSeparator from '@uikit/menu/dropdown/DropdownMenuSeparator.vue'
import AboutFlopDialog from '@/components/dialog/AboutFlopDialog.vue'
import LocaleSelector from '@/components/header/account/LocaleSelector.vue'
import ThemeSelector from '@/components/header/account/ThemeSelector.vue'

import ExternalLinkIcon from '~mingcute/file/external_link_line.svg'
import QuestionIcon from '~mingcute/system/question_line.svg'
</script>

<template>
  <DropdownMenuSeparator />
  <LocaleSelector />
  <ThemeSelector />
  <a :href="DOCUMENTATION_WEBSITE" target="_blank" rel="noreferrer">
    <DropdownMenuItem>
      <template #icon><QuestionIcon /></template>
      <span>{{ $t('header.help') }}</span>
      <template #right><ExternalLinkIcon /></template>
    </DropdownMenuItem>
  </a>
  <DropdownMenuSeparator />
  <div class="account-dropdown-about" @select.prevent>
    <div>{{ $t('header.powered-by') }}</div>
    <span aria-hidden="true">·</span>
    <AboutFlopDialog>
      <RekaDropdownMenuItem class="about-button" :aria-label="$t('about-flop.title')" @select.prevent>
        {{ $t('header.about') }}
      </RekaDropdownMenuItem>
    </AboutFlopDialog>
  </div>
</template>

<style scoped>
.account-dropdown-about {
  padding: 0.25rem 0;
  font-size: 0.75rem;
  color: var(--color-text-muted);

  display: flex;
  justify-content: center;
  gap: 0.25rem;
}

.about-button {
  cursor: pointer;
  text-decoration: underline;
  border-radius: 0.125rem;
  outline: none;
}

.about-button[data-highlighted] {
  color: var(--color-text-accent);
}
</style>
